import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FlagIcon from '../../FlagIcon';
import AuctionHeaderPhase from '../AuctionHeaderPhase';
import AuctionHeaderProgress from '../AuctionHeaderProgress';
import AuctionHeaderQuantity from './AuctionHeaderQuantity';
import AuctionHeaderProduct from '../AuctionHeaderProduct';
import { auctionType } from '../../../types';
import '../_styles_/BidsHeader.css';

BidsHeader.propTypes = {
    hideHandler: PropTypes.func.isRequired,
    auction: auctionType.isRequired,
};

function BidsHeader(props) {
    const {
        hideHandler,
        auction,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="auction-bids--header">
            <div className="auction-header">
                <div className="auction-header--main">
                    {auction.zone.flagCode && (
                        <>
                            <FlagIcon code={auction.zone.flagCode} size="2x" className="auction-header--flag-icon flag-icon--shadowed flag-icon--32" squared />
                            &nbsp;
                        </>
                    )}
                </div>
                <div className="auction-header--name">{auction.name}</div>
                <div className="auction-header--id">{auction.id}</div>
                <AuctionHeaderProduct product={auction.product} />
                <AuctionHeaderQuantity quantity={auction.quantity} />
                <AuctionHeaderProgress auction={auction} />
                <AuctionHeaderPhase phase={auction.phase} />
            </div>
            <button type="button" className="close-button button-small button-primary-text auction-bids--header--close" onClick={hideHandler}>
                <span aria-label={t('auctions.bids-list.dismiss')} role="img"><FontAwesomeIcon icon="times" /></span>
            </button>
        </div>
    );
}

export default BidsHeader;
